import React, { useState } from "react";
import { FaUniversity, FaRupeeSign, FaWallet } from "react-icons/fa";

const WithdrawPage = () => {
  const [amount, setAmount] = useState("");
  const quickAmounts = [100, 500, 1000, 2000, 5000, 10000];
  const balance = 24680;

  return (
    <div className="min-h-screen bg-gray-900 pb-20">
      <div className="bg-gradient-to-b from-blue-900/50 via-gray-900 to-gray-900 pt-6 pb-8">
        <div className="max-w-lg mx-auto px-4">
          <h1 className="text-2xl font-bold text-white mb-6">Withdraw Funds</h1>

          {/* Balance Display */}
          <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-4 mb-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">Available Balance</p>
                <p className="text-2xl font-bold text-white">
                  ₹{balance.toLocaleString()}
                </p>
              </div>
              <FaWallet className="text-blue-500 text-2xl" />
            </div>
          </div>

          {/* Amount Input Section */}
          <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-6">
            <label className="block text-gray-400 text-sm font-medium mb-2">
              Withdrawal Amount
            </label>
            <div className="relative">
              <FaRupeeSign className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full pl-10 pr-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="Enter amount"
                min="100"
                max={balance}
              />
            </div>

            {/* Quick Amount Buttons */}
            <div className="grid grid-cols-3 gap-2 mt-4">
              {quickAmounts.map((amt) => (
                <button
                  key={amt}
                  onClick={() => setAmount(amt)}
                  className="bg-gray-700/50 text-gray-300 py-2 px-4 rounded-lg border border-gray-600 hover:bg-gray-700 transition-colors"
                >
                  ₹{amt}
                </button>
              ))}
            </div>
          </div>

          {/* Bank Details Section */}
          <div className="mt-6 bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-white">Bank Details</h2>
              <FaUniversity className="text-blue-500" />
            </div>

            <div className="space-y-4">
              <button className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white py-4 rounded-xl font-medium hover:from-blue-500 hover:to-blue-400 transition-all shadow-lg shadow-blue-900/20">
                Withdraw Now
              </button>
            </div>

            <p className="mt-4 text-xs text-gray-400">
              *Minimum withdrawal: ₹100 | Maximum withdrawal: ₹50,000
              <br />
              Processing time: 24-48 hours
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawPage;
